import { useState, useEffect } from "react";
import ReactMapGL, { Source, Layer } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";

export default function Location() {
  const [viewport, setViewport] = useState({});
  const [dataId, setDataId] = useState(null);
  const [search, setSearch] = useState();
  const [data, setData] = useState([])
  useEffect(() => {
    navigator.geolocation.getCurrentPosition((pos) => {
      setViewport({
        ...viewport,
        latitude: 38.63738602787579,
        longitude: -121.23576311149986,
        zoom: 4.8,
        bearing: 0,
        pitch: 0,
        dragPan: true,
        width: 600,
        height: 600
      });
    });
  }, [viewport]);

  // const handlepopup = (id) => {
  //   setDataId(id)
  // }
  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   e.stopPropagagtion();
  // }

  // useEffect(() => {
  //   axios.post(`/store-products/search-products`, { name: search }).then((res) => {
  //     console.log(res.data);
  //     let data = res.data;
  //     const newArr = data.map((d) => {
  //       const { seller_store_map_location, ...temp } = d;
  //       const loc = JSON.parse(seller_store_map_location);
  //       const l = {
  //         latitude: loc[0],
  //         longitude: loc[1]
  //       }
  //       const returnObj = {
  //         ...temp,
  //         ...l
  //       }
  //       return returnObj
  //     })
  //     setData(newArr)
  //   })
  // }, [search])
  const dataOne = {
    type: "Feature",
    properties: {},
    geometry: {
      type: "LineString",
      coordinates: [
        [-122.41510269913951, 37.77909036739809],
        [39.5423, -77.0564]
      ]
    }
  };

  return (
    <>
      <div>
        {/* <Row className="d-flex justify-content-center w-50 m-auto">
          <Form onSubmit={handleSubmit}>
            <Row className="align-items-center">
              <Col md={6}>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label>Search Products</Form.Label>
                  <Form.Control type="text" placeholder="Enter anything..." value={search} onChange={(e) => setSearch(e.target.value)} />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Button>Filter</Button>
              </Col>
            </Row>
          </Form>
        </Row> */}
        {viewport.latitude && viewport.longitude && (
          <div>
            <ReactMapGL
              mapboxAccessToken="pk.eyJ1Ijoic2hhaWJpIiwiYSI6ImNraGxqajRyeDB1M3oyd3MyaXE4MG0xZ20ifQ.PY_b9Dadqa6TmtUouX86Gw"
              // initialViewState={viewport}
              {...viewport}
              mapStyle="mapbox://styles/mapbox/streets-v9"
              style={{ position: "absolute" }}
            >
              <Source id="polylineLayer" type="geojson" data={dataOne}>
                <Layer
                  id="lineLayer"
                  type="line"
                  source="my-data"
                  layout={{
                    "line-join": "round",
                    "line-cap": "round"
                  }}
                  paint={{
                    "line-color": "rgba(6, 170, 238, 0.5)",
                    "line-width": 5
                  }}
                />
              </Source>
            </ReactMapGL>

          </div>

        )}

      </div>
    </>
  )
}